import styles from "./users-and-roles.module.css";
import MagnifyingGlassIcon from "../Icons/magnifying-glass-icon";
import CustomSelect from "../CommonComponents/select/CustomSelect";
import { ENTERPRISE, REGIONAL, SUB_REGIONAL } from "../../Enums/administratorLevels";
import { useMemo } from "react";
import { useFetchRolesQuery } from "../../Apis/rolesApi";
import { RolesList } from "../../Model/userObjects";


const typeOptions = [
  { value: "ALL", label: "All" },
  { value: ENTERPRISE, label: "Enterprise" },
  { value: REGIONAL, label: "Region" },
  { value: SUB_REGIONAL, label: "Subregion" },
]

const statusOptions = [
  { value: "ALL", label: "All" },
  { value: "ACTIVE", label: "Active" },
  { value: "INACTIVE", label: "Deactivated" },
  { value: "PENDING", label: "Pending" },
]

const UserControls = ({getFilter, setFilter}) => {
  const { data: roles = new RolesList() } = useFetchRolesQuery();

  const roleOptions = useMemo(() => {
    let result = [
      { value: "ALL", label: "All" },
    ];
    
    roles.getRoles().forEach(role => {
      result.push({
        value: role.getId(),
        label: role.getName(),
      });
    });
    
    return result;
  }, [roles]);


  return (
    <>
      <div className={styles.searchInputWrapper}>
        <span className={styles.searchIcon}>
          <MagnifyingGlassIcon />
        </span>
        <input
          className={styles.searchInput}
          type="text"
          placeholder="Search"
          value={getFilter("SEARCH")}
          onChange={(e) => setFilter("SEARCH", e.target.value)}
        />
      </div>
      <CustomSelect
        options={typeOptions}
        selected={getFilter("TYPE")}
        onSelect={(value) => setFilter("TYPE", value)}
        selectClassName={styles.usersControlsSelect}
        optionClassName={styles.usersControlsSelectOption}
        selectedOptionClassName={styles.usersControlsSelectOptionSelected}
        displayFunc={(o) => o.value === "ALL" ? "Type" : o.label}
      />
      <CustomSelect
        options={roleOptions}
        selected={getFilter("ROLE")}
        onSelect={(value) => setFilter("ROLE", value)}
        selectClassName={styles.usersControlsSelect}
        optionClassName={styles.usersControlsSelectOption}
        selectedOptionClassName={styles.usersControlsSelectOptionSelected}
        displayFunc={(o) => o.value === "ALL" ? "Role" : o.label}
      />
      <CustomSelect
        options={statusOptions}
        selected={getFilter("STATUS")}
        onSelect={(value) => setFilter("STATUS", value)}
        selectClassName={styles.usersControlsSelect}
        optionClassName={styles.usersControlsSelectOption}
        selectedOptionClassName={styles.usersControlsSelectOptionSelected}
        displayFunc={(o) => o.value === "ALL" ? "Status" : o.label}
      />
    </>
  );
};
export default UserControls;
